import React from "react";
import "./Css/AdminLayout.css";
import AppBar from "./Component/AppBar";
import Drawer from "./Component/Drawer";
import { useSelector } from "react-redux";

function AdminLayout(props) {
    const screenReducer = useSelector((state) => state.ScreenReducer);
    const [isSmallView, setSmallView] = React.useState(false);

    React.useEffect(() => {
        setSmallView((screenReducer.screen === 'XS' || screenReducer.screen === 'SM'));
    }, [screenReducer.screen]);

    return (
        <div className={"admin-layout"}>
            

            {/* <== View */}
            <div className={"admin-view"}>
                {/* <== AppBar */}
                {isSmallView && <AppBar {...props} />}
                {/* <== AppBar */}
                <props.view />
            </div>
            {/* View ==> */}
            {/* <== Drawer */}
            <Drawer {...props} />
            {/* Drawer ==> */}
        </div>
    );
}

export default AdminLayout;
